import './App.css';
import NavBar from './components/NavBar';
import {BrowserRouter} from 'react-router-dom'
import {Routes,Route} from 'react-router-dom'
import Todo from './components/Todo';
import Login from './components/Login';
import Signup from './components/Signup';
import { useEffect, useState } from 'react';
import {auth} from './firebase'
import Forgot from './components/Forgot';
function App()   {
  const [user,setUser]=useState('')
  useEffect(()=>{
    auth.onAuthStateChanged(user=>{
      if(user) setUser(user)
      else setUser(null)
    })
  },[])
  return (
  <div>    
    <BrowserRouter>
      <NavBar user={user}/>
           
        <Routes>
          <Route  path='/todo' element={<Todo user={user}/>}/>
          <Route  path='/login' element={<Login/>}/>
          <Route  path='/forgot' element={<Forgot/>}/>
          <Route  path='/signup' element={<Signup/>}/>
          </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
